import React, { useContext, useEffect, useState } from 'react'
import { FaPlus } from 'react-icons/fa6'
import { Link } from 'react-router'
import { BASE_URL_API } from '../../References/URLs'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import AuthContext from '../../store/auth-context'
import styles from './ImHome.module.css'

const ImHome = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier

    const [productsData, setProductsData] = useState([
        { id: 1, name: 'Apple', mrp: 249, stock: 45 },
        { id: 2, name: 'Mango', mrp: 249, stock: 45 },
        { id: 3, name: 'Banana', mrp: 249, stock: 45 },
    ])
    const [filteredData, setFilteredData] = useState([])

    const getInventoryProducts = async () => {
        const response = await fetch(BASE_URL_API + "getInventoryProducts",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx?.token,
                    vendorIdentifier: vendorIdentifier,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setProductsData(respo?.response)
                setFilteredData(respo?.response)
            } else {
                setProductsData([])
                setFilteredData([])
            }
            console.log(respo)
        }
    }

    useEffect(() => {
        getInventoryProducts()
    }, [])

    const filterData = (data, searchKey) => {
        setFilteredData(data?.filter(item =>
            Object.values(item).some(value =>
                value?.toString().toLowerCase().includes(searchKey.toLowerCase())
            )
        ))
    }

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainHeader}>
                <div className={styles.mainTitle}>
                    Product Catalogue
                </div>
                <div className={styles.addProduct}>
                    <Link className={styles.addProductIcon} to={`/manage/inventory/add-products`}> <FaPlus /> Add Product</Link>
                </div>
            </div>
            <div className={styles.searchHeader}>
                <div className={styles.searchHeaderContainer} >
                    <div className={styles.inputWrapper} >
                        <input placeholder="Search products..." onChange={(e) => filterData(productsData, e.target.value)} />
                    </div>
                    {/* <div className={styles.filterWrapper} >
                        <div>
                            <select>
                                <option>Select Category</option>
                            </select>
                        </div>
                        <div>
                            <select>
                                <option>Select Brand</option>
                            </select>
                        </div>
                        <div>
                            <select>
                                <option>Select Stock</option>
                            </select>
                        </div>
                    </div> */}

                </div>
            </div>

            {productsData?.length > 0 ?

                <div className={styles.mainBodyWrapper}>
                    <div className={styles.mainBodyContainer}>
                        <div className={styles.tableHeader}>
                            <div className={styles.sn} >
                                #
                            </div>
                            <div className={styles.productName}>
                                Product
                            </div>
                            <div className={styles.categoryName} >
                                Category
                            </div>
                            <div className={styles.barcode} >
                                SKU / Barcode
                            </div>
                            <div className={styles.mrp}>
                                MRP
                            </div>
                            <div className={styles.price}>
                                S. P.
                            </div>
                            <div className={styles.stock} >
                                Discount(%)
                            </div>
                            <div className={styles.expiry} >
                                Unit / Qty.
                            </div>
                            <div className={styles.action} >
                                Action
                            </div>

                        </div>
                        <div className={styles.productWrapper}>
                            {filteredData?.map((item, index) => (
                                <div key={index} className={styles.eachRowWrapper} >
                                    <div className={styles.sn} >
                                        {index + 1}.
                                    </div>
                                    <div className={styles.productName}>
                                        {item?.productName}
                                    </div>
                                    <div className={styles.categoryName}>

                                    </div>
                                    <div className={styles.barcode}>

                                    </div>
                                    <div className={styles.mrp}>
                                        ₹{item?.printedMrp}
                                    </div>
                                    <div className={styles.price}>
                                        ₹{parseFloat(item.retailPrice).toFixed(2)}
                                    </div>
                                    <div className={styles.stock}>
                                        {item?.discountPercentage}
                                    </div>
                                    <div className={styles.expiry}>
                                        {item?.unit} {item?.quantity}
                                    </div>
                                    <div className={styles.action}>

                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>

                </div>
                :
                <div className={styles.mainBodyWrapper}>
                    <div className={styles.noProduct} >
                        You have not added any product in the inventory yet!
                    </div>
                </div>
            }
        </div>
    )
}

export default ImHome